module.exports = __webpack_public_path__ + "static/40-12b8d11edfb5811a6ee294323af1e149.png";